
// compontents of logo
import { ReactComponent as FiirbotsLogo } from '../assets/logo_fiirbots.svg';

function LogoFiirbots() {
    return (
        <FiirbotsLogo />
    )
}

export default LogoFiirbots;